import React from "react";
import { useNavigate } from "react-router-dom";

export default function TodayCareSummaryDrawer({ open, onClose, todayItems = [], cards = [] }) {
  const navigate = useNavigate();

  if (!open) return null;

  const scheduledCards = cards.filter((c) => c.scheduledToday);

  return (
    <div
      className="fixed inset-0 z-[100000] flex justify-end bg-black/50 backdrop-blur-xs animate-in fade-in duration-200"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="w-full max-w-md h-full bg-[#F8F6FD] shadow-2xl flex flex-col sm:rounded-l-[32px] overflow-hidden animate-in slide-in-from-right duration-300">
        {/* CABEÇALHO HERO COM IDENTIDADE OFICIAL */}
        <div className="p-5 bg-gradient-to-br from-[#421F97] via-[#2E146E] to-[#1D0A4C] text-white flex items-center justify-between shadow-md relative overflow-hidden flex-shrink-0">
          <div className="absolute -right-6 -bottom-6 h-28 w-28 rounded-full bg-purple-400/20 blur-xl pointer-events-none" />

          <div className="relative z-10 flex items-center gap-3">
            <div className="w-11 h-11 rounded-2xl bg-white/15 backdrop-blur-md border border-white/20 flex items-center justify-center text-xl shadow-inner">
              📊
            </div>
            <div>
              <h2 className="text-base font-black tracking-tight text-white leading-tight">
                Cuidados de Hoje
              </h2>
              <p className="text-[11px] font-medium text-purple-200 mt-0.5">
                Resumo detalhado das atividades do dia
              </p>
            </div>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="relative z-10 w-9 h-9 rounded-2xl bg-white/15 hover:bg-white/25 border border-white/20 text-white flex items-center justify-center font-black transition-all active:scale-95 cursor-pointer shadow-xs"
            title="Fechar"
          >
            ✕
          </button>
        </div>

        {/* SUB-BARRA DE STATUS */}
        <div className="px-5 py-3 bg-white border-b border-purple-100 flex items-center justify-between flex-shrink-0">
          <div className="flex items-center gap-1.5">
            <span className="w-2 h-2 rounded-full bg-[#6C54D8]" />
            <span className="text-[11px] font-black text-gray-900 uppercase tracking-wider">
              Programação Ativa
            </span>
          </div>
          <span className="text-[11px] font-bold text-purple-800 bg-purple-100/70 px-2.5 py-0.5 rounded-full">
            {scheduledCards.length} itens hoje
          </span>
        </div>

        {/* CONTEÚDO */}
        <div className="flex-1 overflow-y-auto p-4 space-y-3">
          {scheduledCards.length === 0 ? (
            <div className="p-8 text-center border border-dashed border-purple-200 rounded-3xl bg-white shadow-xs my-auto">
              <div className="w-14 h-14 rounded-2xl bg-purple-50 flex items-center justify-center text-2xl mx-auto mb-3">
                🌿
              </div>
              <h4 className="text-sm font-black text-gray-900 leading-tight">
                Tudo tranquilo por hoje
              </h4>
              <p className="text-xs text-gray-500 mt-1 max-w-xs mx-auto">
                Você não tem outros cuidados pendentes neste momento.
              </p>
            </div>
          ) : (
            scheduledCards.map((card) => (
              <div
                key={card.id}
                onClick={() => {
                  onClose();
                  if (card.route) navigate(card.route);
                }}
                className="p-4 rounded-3xl border border-purple-100/80 bg-white hover:border-purple-300 hover:shadow-md cursor-pointer transition-all duration-200 flex items-center justify-between gap-3 shadow-xs active:scale-98"
              >
                <div>
                  <h4 className="text-xs font-black text-gray-900 leading-tight">{card.title}</h4>
                  <p className="text-[11px] text-gray-500 font-medium mt-0.5">{card.lastValue || "Pendente"}</p>
                </div>

                <span
                  className={`px-2.5 py-1 text-[10px] font-black uppercase rounded-xl border ${
                    card.completionRatio === 1
                      ? "bg-emerald-50 text-emerald-800 border-emerald-200"
                      : card.completionRatio > 0
                      ? "bg-purple-50 text-purple-800 border-purple-200"
                      : "bg-amber-50 text-amber-900 border-amber-200"
                  }`}
                >
                  {card.completionRatio === 1
                    ? "Concluído"
                    : card.completionRatio > 0
                    ? "Parcial"
                    : "Pendente"}
                </span>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
}
